export const HOME_SERVICE = "/home-service";
export const ACCOUNT_SERVICE = "/account-service";
export const ENVIRONMENT_SERVICE = "/environment-service";
export const RESOURCE_SERVICE = "/resource-service";
export const SUBSCRIPTION_SERVICE = "/subscription-service";
export const TASK_SERVICE = "/task-service";
export const FIELDOPERATION_SERVICE = "/fieldoperation-service";
export const DOCUMENT_SERVICE = "/document-service";
export const PRODUCT_SERVICE = "/product-service";
export const MESSAGING_SERVICE = "/messaging-service";

export const SIGNALR_HUBNAME = "attempts";
export const SIGNALR_HUBNAME_GLOBAL = "global";

export const AZURE_AD_LOGIN_URL =
  "https://login.dev.mibuild.com/dev.mibuild.com/B2C_1A_LOCAL_SIGNIN_ROPC/oauth2/v2.0/token";

export const API_VERSION = "2023-12-01";
export const API_VERSION_2023_12_01 = "2023-12-01";
export const API_VERSION_2024_04_22 = "2024-04-22";
export const X_API_VERSION = "X-API-Version";
export const ENABLE_SERVER_SIDE_CACHE_HEADER = "Enable-Server-Side-Cache";
export const IF_MATCH = "If-Match";
export const ACCEPT = "Accept";
export const MV_CSV_COLUMNS = "MV-Csv-Columns";

export const HTTP_METHODS = {
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete",
  POST: "post",
  GET: "get",
};
